import { Injectable, LOCALE_ID, Provider } from '@angular/core';
import { StorageService } from '@shared/services';

export class LocaleService {
  getLocale(): string {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return undefined;
    }

    let browserLang: any = window.navigator['languages'] ? window.navigator['languages'][0] : null;
    browserLang = browserLang || window.navigator.language || window.navigator['browserLanguage'] || window.navigator['userLanguage'];

    if (browserLang.indexOf('-') !== -1) {
      browserLang = browserLang.split('-')[0];
    }

    if (browserLang.indexOf('_') !== -1) {
      browserLang = browserLang.split('_')[0];
    }

    return browserLang;
  }
}

export function localeIdFactory(localeService: LocaleService) {
  return localeService.getLocale();
}

export const localeLoader: Provider = {
  provide: LOCALE_ID,
  deps: [[LocaleService]],
  useFactory: localeIdFactory
};
